import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfigService {

    public config: any;

    public static AppName: string;
    public static SessionGroupCode: string;

    public static ApiUrl: string;
    public static AppUrl: string;

    public static ApiKey: string;

    public static PayPalCurrencyCode: string;

    public static PayPalPaymentMode: string;
    public static PayPalSandboxCliendId: string;
    public static PayPalProductionCliendId: string;

    //custom configurations
    public static StaffConfig: StaffConfig[];

    constructor(private _http: HttpClient) {
    }

    load() {
        var date = new Date();

        var qDate = date.getFullYear().toString()
            + date.getMonth().toString()
            + date.getDay().toString()
            + date.getHours().toString()
            + date.getMinutes().toString()
            + date.getSeconds().toString();

        var env = 'development';

        if (environment.production) env = 'production';

        var obj = this._http.get('./assets/config/' + env + '.json' + "?v=" + qDate)
            .toPromise().then(
                (data: any) => {
                    this.config = data;

                    ConfigService.AppName = this.config.appName;
                    ConfigService.SessionGroupCode = this.config.sessionGroupCode;
                    ConfigService.ApiUrl = this.config.apiUrl;
                    ConfigService.AppUrl = this.config.appUrl;
                    ConfigService.ApiKey = this.config.apiKey;
                    ConfigService.PayPalPaymentMode = this.config.payPalPaymentMode;
                    ConfigService.PayPalCurrencyCode = this.config.payPalCurrencyCode;
                    ConfigService.PayPalSandboxCliendId = this.config.payPalSandboxCliendId;
                    ConfigService.PayPalProductionCliendId = this.config.payPalProductionCliendId;

                    ConfigService.StaffConfig = new Array<StaffConfig>();

                    if (this.config.staffConfig != null) {
                        this.config.staffConfig.forEach(staffConfig => {
                            var data = new StaffConfig();
                            data.StaffName = staffConfig.staffName;
                            data.LimitPreferredTime = JSON.parse(staffConfig.limitPreferredTime);
                            ConfigService.StaffConfig.push(data);
                        });
                    }

                },
                (error: any) => {
                    console.error(error);
                });
        return obj;
    }
}


export class StaffConfig {
    StaffName: string;
    LimitPreferredTime: boolean;
}